// import React, { createContext, useState, useEffect } from 'react';

// // Create AuthContext
// export const AuthContext = createContext();

// // AuthProvider component
// export const AuthProvider = ({ children }) => {
//   const [userId, setUserId] = useState(null);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   // Load userId from localStorage on component mount
//   useEffect(() => {
//     const storedUserId = localStorage.getItem('userId');
//     if (storedUserId) {
//       setUserId(storedUserId);
//       setIsAuthenticated(true);
//     }
//   }, []);

//   // Function to handle login/registration
//   const login = (userId) => {
//     setUserId(userId);
//     setIsAuthenticated(true);
//     localStorage.setItem('userId', userId);
//   };

//   // Function to handle logout
//   const logout = () => {
//     setUserId(null);
//     setIsAuthenticated(false);
//     localStorage.removeItem('userId');
//   };

//   return (
//     <AuthContext.Provider value={{ userId, isAuthenticated, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };
import React, { createContext, useState, useEffect } from 'react';

// Create AuthContext
export const AuthContext = createContext();

// AuthProvider component
export const AuthProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Load userId from localStorage on component mount
  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId);
      setIsAuthenticated(true);
    }
  }, []);

  // Function to handle login/registration
  const login = (userId) => {
    setUserId(userId);
    setIsAuthenticated(true);
    localStorage.setItem('userId', userId);
  };

  // Function to handle logout
  const logout = () => {
    setUserId(null);
    setIsAuthenticated(false);
    localStorage.removeItem('userId');
    localStorage.removeItem('hasSubscription');
  };

  return (
    <AuthContext.Provider value={{ userId, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};